// 页面入参的mixins
import store from "@/store/index"
import { getuserbindmsg } from '@/port/clientSide/multipleChoice.js'
import { cloneDeep } from 'lodash';
import { dealText } from '@/api/common.js'
import { setCustomDefaultData } from '@/util/customData.js'
import { getfilecontent } from '@/port/admins/ai'

const MEDIA_TAGS = 'img|video|audio|iframe|embed|source|track';

// 在 JSON.parse 之前，从原始 JSON 字符串中删除媒体标签
// 用 [^<]* 匹配到下一个 < 为止，而不是 [^>]*
// 这样即使标签内有裸引号或 & 把内容截断，也能被整段清除
function removeMediaTags(jsonStr) {
  return jsonStr.replace(new RegExp(`<(${MEDIA_TAGS})\\b[^<]*`, 'gi'), '');
}

export default {
  data() {
    return {
      paramsList: [], // 页面入参
    }
  },
  methods: {
    // 设置应用的参数
    async setParams (info, id, isApp = false) {
      const customData = info.customData
      for (let i = 0; i < info.customData.length; i++) {
        const item = info.customData[i];
        // 设置默认值
        if (item.type2 && item.type2 !== 'custom') {
          item.value = await setCustomDefaultData(item)
        }
        // 页面入参替换
        // 返回匹配的index数组
        const indexArr = this.findAllIndices(this.paramsList, iter => iter.name === item.name)
        if (indexArr.length > 0) {
          item.value = []
          indexArr.forEach(index => {
            const val = this.paramsList[index].value
            if (Array.isArray(val)) {
              item.value.push(...val)
            } else if (val || val === 0) {
              item.value.push(val)
            }
          })
          if (item.rulerData.fixquery && item.rulerData.fixquery.linked && item.rulerData.fixquery.linked.length > 0) {
            // 参数的条件过滤
            item.value = this.filterVal(item.value, item.rulerData.fixquery.linked)
          } 
        }
        if (item.type === 'relation-user' && item.value.length > 0) {
          if (item.type2 !== 'currentUser') {
            for (let valueIndex = 0; valueIndex < item.value.length; valueIndex++) {
              const userVal = Array.isArray(item.value[valueIndex]) ? item.value[valueIndex][0] : item.value[valueIndex]
              if (typeof userVal === 'object' && userVal && userVal.userId) {
                const { data } = await getuserbindmsg({ userId: userVal.userId })
                if (data) {
                  item.value[valueIndex] = data
                }
              }
            }
          }
        } else if (item.type === 'organization' || item.type === 'roule') {
          // 暂时不用处理
        } else if (item.type === 'date') {
          if (item.type2 === 'range') {
            item.value = Array.isArray(item.value) ? item.value : [item.value, item.value]
          } else {
            item.value = Array.isArray(item.value) && item.value.length > 0 ? item.value[0] : item.value
          }
        } else if (item.type === 'image') {
          for (const file of item.value) {
            if (file.response) {
              const fileName = file.response.replace(/^\/userfiles\//, '');
              const fileContent = await this.getfileCont(fileName);
              file.content = fileContent
            }
          }
        } else {
          // 如果是数组就给他转换成普通的字符串
          item.value = Array.isArray(item.value) ? item.value.join() : item.value
          if (item.type === 'text' && item.value && item.value.search('{') !== -1) {
            const res = dealText({ 
              text: item.value, 
              commonData: store.state.userData, 
              customData: customData, 
              functionParms: item.functionParms || []
            })
            item.value = res || item.value
          }
        }
      }
      if (isApp) {
        return customData
      } else {  
        store.commit('changeCustomData', { key: 'door', value: customData });
        store.commit('changeDoorCustomDataObj', { id, value: customData });
      }
    },
    // 获取别的门户或者场景传过来的变量
    getParams () {
      let paramsList = []
      if (this.$route.path === '/customInstrument' || (this.customDeskInfo && this.customDeskInfo.paramsList)) {
        let customDeskInfoParamsList = this.customDeskInfo && this.customDeskInfo.paramsList
        paramsList = customDeskInfoParamsList && customDeskInfoParamsList.length > 0 ? customDeskInfoParamsList : this.$route.query.paramsList
      } else {
        paramsList = sessionStorage.getItem('paramsList')
      }
      if (paramsList) {
        if (typeof paramsList === 'string') {
          try {
            paramsList = JSON.parse(removeMediaTags(paramsList))
          } catch (e) {
            console.error('paramsList JSON.parse failed:', e)
            paramsList = []
          }
        }
        // 如果传参是空值就不替换
        this.paramsList = paramsList.filter(item => { return Array.isArray(item.value) ? item.value.length > 0 : item.value !== '' })
        sessionStorage.removeItem('paramsList')
      }
      // 处理一下另外一种格式 （表单变量）
      if (this.coverVal) {
        for (const key in this.coverVal) {
          const [ name ] = key.split('_')
          if (key.search('custom') !== -1 && this.coverVal[key]) {
            this.paramsList.push({ name, value: this.coverVal[key] })
          }
        }
      }
    },
    // 找到数组中所有的匹配值
    findAllIndices(arr, fn, ) {
      arr = cloneDeep(arr)
      const indices = [];
      let foundIndex;
      
      while ((foundIndex = arr.findIndex(fn)) !== -1) {
        indices.push(foundIndex);
        arr.splice(foundIndex, 1, {}); // 替换已找到的元素，避免重复索引
      }
      
      return indices;
    },
    filterVal (val, linked) {
      // 数据过滤
      let value = val.filter(v => {
        let isReturn = false
        // 符合规则的参数才能返回
        linked.forEach(rule => {
          if (rule.conditionValue) {
            switch (rule.condition) {
              case 'in': // 包含
                isReturn = rule.conditionValue && rule.conditionValue.includes(v)
                break
              case 'noin': // 不包含
                isReturn = rule.conditionValue && !rule.conditionValue.includes(v)
                break
            }
          } else {
            isReturn = true
          }
        })
        return isReturn
      })
      
      return value
    },
    // 获取文件解析内容
    async getfileCont(file) {
      const resFile = await getfilecontent({
        path: file
      })
      if (resFile.code === 0) {
        return resFile.data
      } else{
        return ''
      }
    },
  },
  created () {
    this.getParams()
  }
}
